import React from 'react';

interface HexagonIconProps {
  size?: number;
}

const HexagonIcon: React.FC<HexagonIconProps> = ({
  size = 24,
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.75,2.56687 C11.5235,2.12029 12.4765,2.12029 13.25,2.56687 L19.5443,6.20084 C20.3178,6.64743 20.7943,7.47274 20.7943,8.36591 L20.7943,15.6339 C20.7943,16.527 20.3178,17.3523 19.5443,17.7989 L13.25,21.4329 C12.4765,21.8795 11.5235,21.8795 10.75,21.4329 L4.45581,17.7989 C3.68231,17.3523 3.20581,16.527 3.20581,15.6339 L3.20581,8.36591 C3.20581,7.47274 3.68231,6.64743 4.45581,6.20084 L10.75,2.56687 Z M12.25,4.29892 C12.0953,4.2096 11.9047,4.2096 11.75,4.29892 L5.45581,7.9329 C5.30111,8.02221 5.20581,8.18728 5.20581,8.36591 L5.20581,15.6339 C5.20581,15.8125 5.30111,15.9776 5.45581,16.0669 L11.75,19.7008 C11.9047,19.7902 12.0953,19.7902 12.25,19.7008 L18.5443,16.0669 C18.699,15.9776 18.7943,15.8125 18.7943,15.6339 L18.7943,8.36591 C18.7943,8.18727 18.699,8.02221 18.5443,7.9329 L12.25,4.29892 Z"
        fill="none"
        stroke="#000000"
        strokeWidth="2"
      />
    </svg>
  );
};

export default HexagonIcon;
